module.exports = __webpack_public_path__ + "img/FPT03.46893273.svg";